import React from "react";
import {FaEnvelope as Mail, FaGithub as Github, FaLinkedin as Linkedin, FaTwitter as Twitter,} from "react-icons/fa"

import Nav from "react-bootstrap/Nav"

export default () => (
    <Nav className="h1 d-none d-sm-none d-md-none d-lg-none d-xl-block"
         style={{listStyle: "none", position: "fixed", maxWidth: "20%", marginTop: "30vh"}}>
        <Nav.Link className="icon my-5" href="mailto://blauigris@gmail.com">
            <Mail/>
        </Nav.Link>
        <Nav.Link className="icon my-5" href="https://twitter.com/blauigris">
            <Twitter/>
        </Nav.Link>
        <Nav.Link className="icon my-5" href="https://es.linkedin.com/in/blauigris">
            <Linkedin/>
        </Nav.Link>
        <Nav.Link className="icon my-5" href="https://github.com/blauigris">
            <Github/>
        </Nav.Link>
    </Nav>
)